import { FC, useEffect } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { observer } from 'mobx-react-lite'
import { useRpStandForm } from './useRpStandForm'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import { TRpStandFormData } from './schema'
import { WrapDrawerCreateForm } from '../index'
import RpStandFormBase from './base'
import { CreateRpStandPayload } from '../../prp2boxApi/stands'
import { Prp2boxApiStands } from '../../prp2boxApi'
import { useStore } from '../../stores'

const RpStandFormCreate: FC = observer(() => {
  const { antMediaStore } = useStore()
  const queryClient = useQueryClient()
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useRpStandForm()

  useEffect(() => {
    ;(async () => {
      return antMediaStore.getList()
    })()
  }, [])

  const createMutation = useMutation((payload: CreateRpStandPayload) => Prp2boxApiStands.create(payload), {
    onSuccess: () => {
      toast.success('Стойка успешно создана')
      queryClient.invalidateQueries([EQueryKeysConstant.RP_STANDS])
    },
  })

  const handleSave = (data: TRpStandFormData) => {
    const { name, stream } = data

    createMutation.mutate({
      name,
      stream: {
        id: stream,
        name: antMediaStore.findStreamNameById(data.stream),
      },
    })
  }

  return (
    <WrapDrawerCreateForm title="Создание новой стойки" onSave={handleSubmit(handleSave)}>
      <RpStandFormBase
        register={register}
        errors={errors}
        control={control}
        streamOptions={antMediaStore.streamsOptions}
      />
    </WrapDrawerCreateForm>
  )
})

export default RpStandFormCreate
